// extracted by mini-css-extract-plugin
module.exports = {"viq69dn":"viq69dn","n6yqcst":"n6yqcst","sub-tab":"sub-tab","active":"active","tab":"tab","uzs5x9h":"uzs5x9h"};